import monitor, { EVENT_TYPES } from '../../../../../../service/bigquery';
import { getIdeaPageName } from '../getIdeaPageName';

/**
 * @typedef Input
 * @property {String} elementText
 * @property {'top_page'|'middle'|'bottom_page'} elementPosition
 * @property {String} elementName
 * @property {String} pageTagType
 * @property {String} pageTagId
 * @param {Input}
 * @returns {void}
 */
export const getStartedClicked = ({ elementText, elementPosition, elementName, pageTagType, pageTagId }) => {
    const sendData = {
        page: {
            name: getIdeaPageName(pageTagType, pageTagId),
            element: {
                position: elementPosition,
                name: elementName,
                text: elementText,
            },
        },
    };

    monitor.track(EVENT_TYPES.GET_STARTED_BUYER_CLICKED, sendData);
};
